import type { Point2d } from "."

export const rotatePoint = (
  origin: Point2d,
  point: Point2d,
  deg: number,
  log = false,
): Point2d => {
  const rad = (deg * Math.PI) / 180
  const cos = Math.cos(rad)
  const sin = Math.sin(rad)
  const x = (point.x - origin.x) * cos - (point.y - origin.y) * sin + origin.x
  const y = (point.x - origin.x) * sin + (point.y - origin.y) * cos + origin.y
  if (log) {
    console.log({
      deg,
      origin,
      point,
      newPoint: { x, y },
    })
  }

  return { x, y }
}
